import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import App from './App';
import { GameErrorBoundary } from './components/GameErrorBoundary';
import { installClientDiagnostics } from './util/clientDiagnostics';
import reportWebVitals from './reportWebVitals';
import Phaser from 'phaser';
import {installMobileTextureCompatibility} from './util/mobileCombatTextures';

installMobileTextureCompatibility(Phaser);
installClientDiagnostics();

ReactDOM.render(
  <React.StrictMode>
    <GameErrorBoundary><App /></GameErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
window.dispatchEvent(new Event('pknin:website-ready'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
